import axios, { AxiosPromise } from "axios";

import { coursesApi } from "@services/apiMembersClient";
import {
  GetPreferenceInput,
  GetPreferenceOutput,
  RemoveLogoInput,
  UpdatePreferenceInput,
  UpdatePreferenceOutput,
} from "@_types/preferences";
import { CreateSignedUrlInput, CreateSignedUrlOutput, UploadSignedUrlInput } from "@_types/shared";

export const getPreference = ({ uuid }: GetPreferenceInput): AxiosPromise<GetPreferenceOutput> => {
  return coursesApi.get(`/courses/${uuid}/preferences`);
};

export const updatePreference = ({ uuid, ...data }: UpdatePreferenceInput): AxiosPromise<UpdatePreferenceOutput> => {
  return coursesApi.patch(`/courses/${uuid}/preferences`, { ...data });
};

export const createLogoSignedUrl = (uuid: string, data: CreateSignedUrlInput): AxiosPromise<CreateSignedUrlOutput> => {
  return coursesApi.post(`/courses/${uuid}/preferences/logo`, data);
};

export const uploadLogoToSignedUrl = (url: string, formData: UploadSignedUrlInput) => {
  return axios.postForm(url, formData);
};

export const removeLogo = ({ uuid }: RemoveLogoInput): AxiosPromise => {
  return coursesApi.delete(`/courses/${uuid}/preferences/logo`);
};
